import { gql } from '@apollo/client';

import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';

const ACKNOWLEDGE_SYSTEM_MESSAGE= gql`
  mutation($ack: SystemMessageInput) {
    AckSystemMessage(ack: $ack)
  }
`;

export function useMessageMutations() {

  const [acknowledge] = useMutation(ACKNOWLEDGE_SYSTEM_MESSAGE,
    { refetchQueries: ['getSystemMessages']});
  
  return { acknowledge };
}
